var kulture = [
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "čebula"
	},
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "šalotka"
	},
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "česen"
	},
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "por"
	},
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "drobnjak"
	},
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "zimski luk"
	},
	{
	  "skupina": "ČEBULNICE",
	  "naziv": "čebulnice"
	},
	{
	  "skupina": "DREVESNICE",
	  "naziv": "male drevesnice"
	},
	{
	  "skupina": "DREVESNICE",
	  "naziv": "drevesnice"
	},
	{
	  "skupina": "DRUGA ZELENJAVA",
	  "naziv": "zelenjava v zavarovanih prostorih"
	},
	{
	  "skupina": "DRUGA ZELENJAVA",
	  "naziv": "zelenjava"
	},
	{
	  "skupina": "DRUGE POLJŠČINE",
	  "naziv": "poljščine"
	},
	{
	  "skupina": "DRUGE POLJŠČINE ZA SEME",
	  "naziv": "poljščine"
	},
	{
	  "skupina": "GOBE",
	  "naziv": "šampinjoni - kukmaki"
	},
	{
	  "skupina": "GOBE",
	  "naziv": "ostrigarji"
	},
	{
	  "skupina": "GOBE",
	  "naziv": "šitake"
	},
	{
	  "skupina": "GOBE",
	  "naziv": "gobe"
	},
	{
	  "skupina": "grmovje",
	  "naziv": "grmovje"
	},
	{
	  "skupina": "HMELJ",
	  "naziv": "hmelj"
	},
	{
	  "skupina": "IS TRAVNIŠKI SADOVNJAK RAZLIČNIH SADNIH VRST",
	  "naziv": "različne intenzivne sadne vrste "
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "brusnice"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "goji jagode"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "sibirska borovnica"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "črni ribez"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "rdeči ribez"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "maline"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "robide"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "jagode"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "kosmulje"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "josta"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "murva"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "ameriške borovnice"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "bezeg"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "aronija"
	},
	{
	  "skupina": "JAGODIČEVJE IS",
	  "naziv": "jagodičevje"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "šmarna hrušica"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "brusnice"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "goji jagode"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "sibirska borovnica"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "črni ribez"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "rdeči ribez"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "maline"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "robide"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "jagode"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "kosmulje"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "josta"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "murva"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "ameriške borovnice"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "bezeg"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "aronija"
	},
	{
	  "skupina": "JAGODIČEVJE SD",
	  "naziv": "jagodičevje"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "grenivka"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "mandarine"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "pomarančevec"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "rakitovec"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "skorš"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "limone"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "kaki"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "smokve"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "aktinidija"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "citrusi"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "južno sadje"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "feioja"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "žižula"
	},
	{
	  "skupina": "JUŽNO SADJE IS",
	  "naziv": "asimina"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "bergamotka"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "mandarine"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "pomaranče"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "rakitovec"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "skorš"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "grenivka"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "limonovec"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "kaki"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "smokve"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "aktinidija"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "citrusi"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "južno sadje"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "feioja"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "žižula"
	},
	{
	  "skupina": "JUŽNO SADJE SD",
	  "naziv": "asimina"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "ohrovt (brstični)"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "zelje"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "ohrovt (listnati)"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "brokoli"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "cvetača"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "kolerabica"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "kitajsko zelje"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "kapusnice"
	},
	{
	  "skupina": "KAPUSNICE",
	  "naziv": "ohrovt (glavnati)"
	},
	{
	  "skupina": "KONOPLJA",
	  "naziv": "konoplja"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "črna redkev"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "koleraba"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "repa"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "kardij"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "korenček in korenje"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "peteršilj"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "pastinak oz.navadni rebrinec"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "redkvica"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "zelena"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "vrtna repa"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "podzemna koleraba "
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "rdeča pesa "
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "korenovke "
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "črni koren"
	},
	{
	  "skupina": "KORENOVKE IN GOMOLJEVKE",
	  "naziv": "gomoljnice"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "dren"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "češnja"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "višnja"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "breskev"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "marelica"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "nektarina"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "sliva"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "češplja"
	},
	{
	  "skupina": "KOŠČIČARJI IS",
	  "naziv": "koščičarji"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "dren"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "češnja"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "višnja"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "breskev"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "marelica"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "nektarina"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "sliva"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "češplja"
	},
	{
	  "skupina": "KOŠČIČARJI SD",
	  "naziv": "koščičarji"
	},
	{
	  "skupina": "LUPINARJI IS",
	  "naziv": "Pekan oreh"
	},
	{
	  "skupina": "LUPINARJI IS",
	  "naziv": "oreh"
	},
	{
	  "skupina": "LUPINARJI IS",
	  "naziv": "lešniki"
	},
	{
	  "skupina": "LUPINARJI IS",
	  "naziv": "mandelj"
	},
	{
	  "skupina": "LUPINARJI IS",
	  "naziv": "kostanj"
	},
	{
	  "skupina": "LUPINARJI IS",
	  "naziv": "lupinarji"
	},
	{
	  "skupina": "LUPINARJI SD",
	  "naziv": "Pekan oreh"
	},
	{
	  "skupina": "LUPINARJI SD",
	  "naziv": "oreh"
	},
	{
	  "skupina": "LUPINARJI SD",
	  "naziv": "lešniki"
	},
	{
	  "skupina": "LUPINARJI SD",
	  "naziv": "mandelj"
	},
	{
	  "skupina": "LUPINARJI SD",
	  "naziv": "kostanj"
	},
	{
	  "skupina": "LUPINARJI SD",
	  "naziv": "lupinarji "
	},
	{
	  "skupina": "MATIČNJAKI",
	  "naziv": "matičnjaki"
	},
	{
	  "skupina": "MEŠANA RABA: VRTNINE(V), POLJŠČINE (P), NJIVSKA ZELIŠČA (NZ) NA PROSTEM",
	  "naziv": "mešana raba"
	},
	{
	  "skupina": "NAMIZNO GROZDJE IS",
	  "naziv": "namizno grozdje"
	},
	{
	  "skupina": "NAMIZNO GROZDJE SD",
	  "naziv": "namizno grozdje"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "perovskija"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "dren"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "lapuh"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "laški smilj"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kronska marjetica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "krvavi mlečnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "vratič"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "brestovo listni oslad "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "čistec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "jasmin"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "rožni koren"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "monarda"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "jiagulan zelišče življenja"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ašvaganda"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "lovor"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "aloja"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "srčna moč"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "brogovita"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "dišeča perla"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "lučnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ptičja dresen"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "regelj"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "chia"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "artičoka"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "žametnica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "črna meta"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "plavica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "materina dušica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "zlata melisa"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "različne mete"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "grško seno"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "dobra misel"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "sladki janež (sladki komarček)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "zdravilni čistec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "smilj"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kapucinka"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "stevia"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "limonska trava"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "vrtnica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "nemški rožmrin"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "marjetica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "pravi ranjak"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "sladki pelin"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "curry"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "roženkravt"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kurkuma"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "prava krebuljica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ingver"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "Malina list"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "rožlin"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "abrašica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "netresk"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "konjska griva "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "navadna črnobina"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "krhlika"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "gadovec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "repuh"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "rosnica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "tolščak"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "svetlobni koren"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "himalajski kovačnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "hibiskus"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "šišandra"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "navadni kristavec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "senega"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "koriander"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kumina"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "koper"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "lan "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "vrtni janež (koromač)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "luštrek"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "janež "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "pehtran"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "boreč"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "majaron"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "timijan (vrtna materina dušica)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "drobnjak"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "bazilika"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kretski origano"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "arnika "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "baldrijan"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "bela mrtva kopriva"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "beli vratič"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "bolhač"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "borago"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "citronka"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "divja mačeha"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "drobnocvetni vrbovec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "dvoletni svetlin "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "gabez"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "gorski vrednik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "gosji petoprstnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "navadni gozdni koren (Angelika)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "hermelika"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "indijski trpotec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "izop (ožepek)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "jeglič (pomladanski)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "jetičnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kamilica "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kitajski ožepek"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "klasasta meta"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kolmež"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kopriva"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "kordabenedikta (benediktinka)"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "melisa"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "milnica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "muškatna kadulja"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ognjič"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ozkolistni ameriški slamnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ozkolistni trpotec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "pegasti badelj "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "pravi pelin"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "plahtica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "poprova meta "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "škrlatni ameriški slamnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "repik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "regrat"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "riček"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "rman"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "rožmarin"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "rumeni svišč ali košutnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "sivka"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "sladki koren"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "slez"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "slezenovec"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "srčnica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "šentjanževka"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "šetraj"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "ajda "
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "tavžentroža"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "velecvetni lučnik"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "veliki oman"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "vinska rutica"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "zlata rozga"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "žafranika"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "žajbelj"
	},
	{
	  "skupina": "NJIVSKA ZELIŠČA",
	  "naziv": "njivska zelišča"
	},
	{
	  "skupina": "OLJKA",
	  "naziv": "oljke"
	},
	{
	  "skupina": "OSTALI TRAJNI NASADI",
	  "naziv": "trajni nasadi"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "jablana"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "hruške"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "naši"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "kutina"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "nešplja"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "pečkarji"
	},
	{
	  "skupina": "PEČKARJI IS",
	  "naziv": "granatno jabolko"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "jabolko"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "hruška"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "naši"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "kutina"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "nešplja"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "pečkarji"
	},
	{
	  "skupina": "PEČKARJI SD",
	  "naziv": "granatno jabolko"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "buča"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "paradižnik"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "paprika"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "feferoni"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "jajčevci"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "kumare"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "navadna buča"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "melona"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "lubenica"
	},
	{
	  "skupina": "PLODOVKE",
	  "naziv": "plodovke "
	},
	{
	  "skupina": "PRIDELAVA SADIK",
	  "naziv": "sadike"
	},
	{
	  "skupina": "PRIDELAVA SEMEN",
	  "naziv": "semena"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna marjetica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna trobentica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "repinec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "ginko"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "bezeg"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "Akacija"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "ščetica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna kislica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "arnika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "kela"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadni bršljan"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lapuh"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "pušpan"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "smetlika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "veliki jesen"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "voščena mirika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "glavinec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna zobačica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna strašnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna nokota"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "madronščica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "plazeči petoprstnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "praport"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadni svinjak"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "jelka"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "plazeči skrečnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "limonski ožep"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "žafran"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "črna lahkotnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "bluščec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "naprstec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "kilavec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "mirta"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "kačja dresen"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "gosji petoprstnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna črnoglvka "
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "osat"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "drobnocvetni rogovilček"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "bela metlika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "čudiviti klinček"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "velikonočnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "rogovilček"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "breza"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lovor"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna zvezdica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "japonski dresnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "jesenska vresa"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "srobot"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "zimzelen"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "grebenuša"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lučnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "kloščevec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "grindelia"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "brošč"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadni ruj"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "materina dušica "
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "vijolica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "smrdljivka"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "črna detelja"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "ranjak"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "Robida list"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "škrbinka"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "ptičja dresen"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "smilj"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "podraščec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "regačica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "divja češnja"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "plazeči skrečnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "bršljinasta grenkuljica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "potrošnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "vrba"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "bor"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "borovnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "brest"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "cipresa"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "divji kostanj"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "hrast"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "jerebika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "krvomočnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "sladka koreninica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "nepozebnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "morska loboda"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "mala strašnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "repuh"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadna regačica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "glistovnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "volčja češnja"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "šebenik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "veliki bedrenec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadni berdenec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "pokončni petoprstnik "
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "konopljika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "navadni dežen"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "li kilavec "
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lobodika"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "šipek"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "brin"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "tavžentroža"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "regrat"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "rman"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "trpotec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "slez"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "slezenovec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "šetraj"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "črni trn"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "trnulje"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "glog"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "šentjanževka"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "plešec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "kopriva"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "vrbovec"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "zlata rozga"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lakota"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "plahtica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "meta"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "drnulja"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "robida"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "sporiš"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "češmin"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "oman"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "pljučnik"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "jagodnjak"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "preslica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "oslad"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "žajbelj"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "čemaž"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "baldrijan"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "mokovnica"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lipa"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "divji luk"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "poljski mak"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "gorska nebina"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "bela omela"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lubje vrbe"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "lubje hrasta"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "vršički smreke"
	},
	{
	  "skupina": "SAMONIKLE RASTLINE",
	  "naziv": "vršički bora"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "čebula sadike"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "šalotka"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "česen"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "por"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "drobnjak"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "zimski luk"
	},
	{
	  "skupina": "SADIKE ČEBULNIC",
	  "naziv": "čebulnice"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "črni ribez"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "rdeči ribez"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "maline "
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "robide "
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "jagode sadike"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "kosmulje"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "josta"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "murva"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "ameriške borovnice sadike"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "bezeg"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "aronija sadike"
	},
	{
	  "skupina": "SADIKE JAGODIČEVJA",
	  "naziv": "jagodičevje"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "kaki"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "figa ali smokva"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "aktinidija"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "citrusi"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "južno sadje"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "feioja sadike"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "asimina"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "žižula"
	},
	{
	  "skupina": "SADIKE JUŽNEGA SADJA",
	  "naziv": "oljka sadike"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "zelje sadike"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "ohrovt"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "brokoli"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "cvetača"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "kolerabica"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "kitajsko zelje"
	},
	{
	  "skupina": "SADIKE KAPUSNIC",
	  "naziv": "kapusnice"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "korenje"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "peteršilj"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "pastinak oz.navadni rebrinec"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "črni koren"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "redkvica"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "zelena"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "vrtna repa"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "podzemna koleraba sadike"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "rdeča pesa sadike"
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "korenovke "
	},
	{
	  "skupina": "SADIKE KORENOVK IN GOMOLJNIC",
	  "naziv": "gomoljnice"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "češnja"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "višnja"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "breskev"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "marelica"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "nektarina"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "sliva in češplja sadike"
	},
	{
	  "skupina": "SADIKE KOŠČIČARJEV",
	  "naziv": "koščičarji"
	},
	{
	  "skupina": "SADIKE LUPINARJEV",
	  "naziv": "oreh sadika"
	},
	{
	  "skupina": "SADIKE LUPINARJEV",
	  "naziv": "leska sadika"
	},
	{
	  "skupina": "SADIKE LUPINARJEV",
	  "naziv": "mandelj"
	},
	{
	  "skupina": "SADIKE LUPINARJEV",
	  "naziv": "kostanj"
	},
	{
	  "skupina": "SADIKE LUPINARJEV",
	  "naziv": "lupinarji"
	},
	{
	  "skupina": "SADIKE PEČKARJEV",
	  "naziv": "jabolka"
	},
	{
	  "skupina": "SADIKE PEČKARJEV",
	  "naziv": "hruška sadika"
	},
	{
	  "skupina": "SADIKE PEČKARJEV",
	  "naziv": "naši"
	},
	{
	  "skupina": "SADIKE PEČKARJEV",
	  "naziv": "kutina"
	},
	{
	  "skupina": "SADIKE PEČKARJEV",
	  "naziv": "nešplja"
	},
	{
	  "skupina": "SADIKE PEČKARJEV",
	  "naziv": "pečkarji"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "paradižnik"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "paprika"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "feferoni"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "jajčevci oz.melancani"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "kumare"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "bučke"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "melone oz.dinje"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "lubenice"
	},
	{
	  "skupina": "SADIKE PLODOVK",
	  "naziv": "plodovke sadike"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "solata sadike"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "endivija"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "radič"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "motovilec"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "rukola sadike"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "vrtna kreša"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "regrat"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "špinača"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "blitva"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "solatnice sadike"
	},
	{
	  "skupina": "SADIKE SOLATNIC IN ŠPINAČNIC",
	  "naziv": "špinačnice"
	},
	{
	  "skupina": "SADIKE STROČNIC",
	  "naziv": "fižol sadike"
	},
	{
	  "skupina": "SADIKE STROČNIC",
	  "naziv": "grah"
	},
	{
	  "skupina": "SADIKE STROČNIC",
	  "naziv": "soja sadike"
	},
	{
	  "skupina": "SADIKE STROČNIC",
	  "naziv": "leča"
	},
	{
	  "skupina": "SADIKE STROČNIC",
	  "naziv": "bob"
	},
	{
	  "skupina": "SADIKE STROČNIC",
	  "naziv": "stročnice"
	},
	{
	  "skupina": "SADIKE TRAJNIC",
	  "naziv": "rabarbara"
	},
	{
	  "skupina": "SADIKE TRAJNIC",
	  "naziv": "beluši oz.šparglji"
	},
	{
	  "skupina": "SADIKE TRAJNIC",
	  "naziv": "hren"
	},
	{
	  "skupina": "SADIKE TRAJNIC",
	  "naziv": "artičoka"
	},
	{
	  "skupina": "SADIKE TRAJNIC",
	  "naziv": "trajnice"
	},
	{
	  "skupina": "SADIKE VINSKE TRTE",
	  "naziv": "vinska trta"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "koper"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "kumina"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "koriander"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "sladki janež (sladki komarček)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "vrtni janež (koromač)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "luštrek"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "janež"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "pehtran"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "boreč"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "majaron"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "timijan (vrtna materina dušica)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "drobnjak"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "bazilika"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "dobra misel"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "arnika"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "baldrijan"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "bela mrtva kopriva"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "beli vratič"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "bolhač"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "borago"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "citronka"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "divja mačeha"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "drobnocvetni vrbovec"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "dvoletni svetlin"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "gabez"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "gorski vrednik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "gosji petoprstnik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "navadni gozdni koren (angelika)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "hermelika"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "indijski trpotec"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "izop (ožepek)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "jeglič (pomladanski)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "jetičnik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "kamilica sadika"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "kitajski ožepek"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "klasasta meta"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "kolmež"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "kopriva"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "kordabenedikta (benediktinka)"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "melisa"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "milnica"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "muškatna kadulja"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "ognjič"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "ozkolistni ameriški slamnik "
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "ozkolistni trpotec"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "pegasti badelj sadika"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "pravi pelin"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "plahtica"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "poprova meta"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "škrlatni ameriški slamnik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "repik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "regrat"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "riček"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "rman"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "rožmarin"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "rumeni svišč ali košutnik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "sivka"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "sladki koren"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "slez"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "slezenovec"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "srčnica"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "šentjanževka"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "šetraj"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "žametnica"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "tavžentroža"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "velecvetni lučnik"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "veliki oman"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "vinska rutica"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "zlata rozga"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "žafranika"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "žajbelj"
	},
	{
	  "skupina": "SADIKE ZELIŠČ",
	  "naziv": "zelišča sadika"
	},
	{
	  "skupina": "SD TRAVNIŠKI SADOVNJAK RAZLIČNIH SADNIH VRST",
	  "naziv": "različne ekstenzivne sadne vrste"
	},
	{
	  "skupina": "SD TRAVNIŠKI SADOVNJAK RAZLIČNIH SADNIH VRST",
	  "naziv": "različne sadne vrste"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "čebula seme"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "šalotka"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "česen"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "por"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "drobnjak"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "zimski luk"
	},
	{
	  "skupina": "SEME ČEBULNIC",
	  "naziv": "čebulnice"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "zelje seme"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "ohrovt"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "brokoli"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "cvetača"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "kitajsko zelje"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "kapusnice"
	},
	{
	  "skupina": "SEME KAPUSNIC",
	  "naziv": "kolerabica"
	},
	{
	  "skupina": "SEME KONOPLJE",
	  "naziv": "konoplja"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "redkvica"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "korenje"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "peteršilj"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "pastinak oz.navadni rebrinec"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "črni koren"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "zelena"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "vrtna repa"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "podzemna koleraba seme"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "rdeča pesa seme"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "korenovke"
	},
	{
	  "skupina": "SEME KORENOVK IN GOMOLJNIC",
	  "naziv": "gomoljnice"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "njivska grašica"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "detelja seme"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "lucerna"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "volčji bob"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "grahor"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "medena detelja"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "turška detelja"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "šmarna detelja"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "medenica"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "navadna nokota"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "vzhodna jastrebina"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "sabljasti triplat"
	},
	{
	  "skupina": "SEME KRMNIH METULJNIC",
	  "naziv": "krmne metuljnice seme"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "oljna redkev"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmne rastline"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "DTM"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmni grah"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmni bob"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "sladka lupina"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmna pesa "
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmna repa"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmna ogrščica"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmna repica"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmni ohrovt"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmni radič"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmno korenje"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "podzemna koleraba (kavla)"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "strniščna repa"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "bela gorjušica"
	},
	{
	  "skupina": "SEME KRMNIH RASTLIN",
	  "naziv": "krmni sirek"
	},
	{
	  "skupina": "SEME KROMPIRJA",
	  "naziv": "krompir seme"
	},
	{
	  "skupina": "SEME LANU",
	  "naziv": "lan"
	},
	{
	  "skupina": "SEME OLJNIC",
	  "naziv": "sončnice"
	},
	{
	  "skupina": "SEME OLJNIC",
	  "naziv": "oljna buča"
	},
	{
	  "skupina": "SEME OLJNIC",
	  "naziv": "oljna ogrščica"
	},
	{
	  "skupina": "SEME OLJNIC",
	  "naziv": "soja seme"
	},
	{
	  "skupina": "SEME OLJNIC",
	  "naziv": "oljnice"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "paradižnik seme"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "paprika"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "feferoni"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "jajčevci oz.melancani"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "kumare"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "bučke"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "melone oz.dinje"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "lubenice"
	},
	{
	  "skupina": "SEME PLODOVK",
	  "naziv": "plodovke seme"
	},
	{
	  "skupina": "SEME SLADKORNE PESE",
	  "naziv": "sladkorna pesa"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "špinačnice"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "solata seme"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "endivija"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "radič"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "motovilec"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "rukola seme"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "vrtna kreša"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "regrat"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "špinača"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "blitva"
	},
	{
	  "skupina": "SEME SOLATNIC IN ŠPINAČNIC",
	  "naziv": "solatnice seme"
	},
	{
	  "skupina": "SEME STROČNIC",
	  "naziv": "fižol seme"
	},
	{
	  "skupina": "SEME STROČNIC",
	  "naziv": "grah"
	},
	{
	  "skupina": "SEME STROČNIC",
	  "naziv": "soja seme stročnic"
	},
	{
	  "skupina": "SEME STROČNIC",
	  "naziv": "leča"
	},
	{
	  "skupina": "SEME STROČNIC",
	  "naziv": "bob"
	},
	{
	  "skupina": "SEME STROČNIC",
	  "naziv": "stročnice"
	},
	{
	  "skupina": "SEME TRAJNIC",
	  "naziv": "rabarbara"
	},
	{
	  "skupina": "SEME TRAJNIC",
	  "naziv": "beluši oz.šparglji"
	},
	{
	  "skupina": "SEME TRAJNIC",
	  "naziv": "hren"
	},
	{
	  "skupina": "SEME TRAJNIC",
	  "naziv": "artičoka"
	},
	{
	  "skupina": "SEME TRAJNIC",
	  "naziv": "trajnice"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "borago"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "citronka"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "divja mačeha"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "drobnocvetni vrbovec"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "dvoletni svetlin"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "gabez"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "gorski vrednik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "gosji petoprstnik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "navadni gozdni koren (angelika)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "hermelika"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "indijski trpotec"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "izop (ožepek)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "jeglič (pomladanski)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "jetičnik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "kamilica seme"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "kitajski ožepek"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "klasasta meta"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "kolmež"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "kopriva"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "kordabenedikta (benediktinka)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "melisa"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "milnica"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "muškatna kadulja"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "ognjič"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "ozkolistni ameriški slamnik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "ozkolistni trpotec"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "pegasti badelj seme"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "pravi pelin"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "plahtica"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "poprova meta"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "škrlatni ameriški slamnik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "repik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "regrat"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "riček"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "rman"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "rožmarin"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "rumeni svišč ali košutnik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "sivka"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "sladki koren"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "slez"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "slezenovec"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "srčnica"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "šentjanževka"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "šetraj"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "tavžentroža"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "veliki oman"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "vinska rutica"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "zlata rozga"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "žafranika"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "žajbelj"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "zelišča seme"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "dobra misel"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "velecvetni lučnik"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "koper"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "kumina"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "koriander"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "sladki janež (sladki komarček)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "vrtni janež (koromač)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "luštrek"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "janež"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "pehtran"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "boreč"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "majaron"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "timijan (vrtna materina dušica)"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "drobnjak"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "bazilika"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "žametnica"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "arnika"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "baldrijan"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "bela mrtva kopriva"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "beli vratič"
	},
	{
	  "skupina": "SEME ZELIŠČ",
	  "naziv": "bolhač"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "pšenica"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "rž"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "pira"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "ajda seme"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "koruza za zrnje"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "silažna koruza"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "tritikala"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "oves seme"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "ječmen"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "proso"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "mešanica žit"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "soržica"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "sladka koruza"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "sirek"
	},
	{
	  "skupina": "SEME ŽIT",
	  "naziv": "žita"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "solata "
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "endivija"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "radič"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "motovilec"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "rukola "
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "vrtna kreša"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "regrat"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "špinača"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "blitva"
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "solatnice "
	},
	{
	  "skupina": "SOLATNICE IN ŠPINAČNICE",
	  "naziv": "špinačnice"
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "čičerika"
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "fižol "
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "grah"
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "soja "
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "leča"
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "bob"
	},
	{
	  "skupina": "STROČNICE",
	  "naziv": "stročnice"
	},
	{
	  "skupina": "TRAJNICE",
	  "naziv": "rabarbara"
	},
	{
	  "skupina": "TRAJNICE",
	  "naziv": "beluši oz.šparglji"
	},
	{
	  "skupina": "TRAJNICE",
	  "naziv": "hren"
	},
	{
	  "skupina": "TRAJNICE",
	  "naziv": "artičoka"
	},
	{
	  "skupina": "TRAJNICE",
	  "naziv": "trajnice"
	},
	{
	  "skupina": "TRSNICE",
	  "naziv": "trsnice"
	},
	{
	  "skupina": "TRTA ZA DRUGO RABO, KI NI VINO (LE IZVEN VINOGRADNIŠKEGA OBMOČJA)",
	  "naziv": "trta za drugo rabo"
	},
	{
	  "skupina": "VINSKA TRTA",
	  "naziv": "vinska trta"
	}
   ]

   export default kulture;
